(function () {
  var page = document.querySelector(".digger-hitch-size-page");
  if (!page) return;

  var table = page.querySelector(".rte table");
  var filters = page.querySelector("[data-hitch-filters]");
  var searchInput = page.querySelector("[data-hitch-search]");
  var brandSelect = page.querySelector("[data-hitch-brand]");
  var weightSelect = page.querySelector("[data-hitch-weight]");
  var pageSizeSelect = page.querySelector("[data-hitch-page-size]");
  var clearButton = page.querySelector("[data-hitch-clear]");
  var resultCount = page.querySelector("[data-hitch-count]");
  var suggestionMessage = page.querySelector("[data-hitch-suggestion]");
  var emptyState = page.querySelector("[data-hitch-empty]");
  var paginationGroups = Array.prototype.slice.call(page.querySelectorAll("[data-hitch-pagination-bottom]"));
  var pageNumberContainers = [];

  if (!table || !filters || !searchInput || !brandSelect || !weightSelect || !pageSizeSelect || !clearButton || !resultCount || !suggestionMessage || !emptyState) return;

  var rows = [];
  var headerLabels = [];
  var brandValues = [];
  var weightValues = [];
  var weightIndex = 2;
  var currentPage = 1;
  var closestMatchLimit = 15;
  var hasUserSetPageSize = false;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normaliseSearchValue(value) {
    var lower = (value || "")
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
    var readable = lower
      .replace(/[\s\-_\/\.,]+/g, " ")
      .replace(/[^a-z0-9 ]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return {
      readable: readable,
      compact: readable.replace(/\s+/g, ""),
      tokens: readable ? readable.split(" ") : []
    };
  }

  function normalise(value) {
    return normaliseSearchValue(value).readable;
  }

  function getCellText(cell) {
    return (cell.textContent || "").replace(/\s+/g, " ").trim();
  }

  function uniqueSorted(values) {
    var seen = {};
    return values.filter(function (value) {
      var key = normalise(value);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    }).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    });
  }

  function addOptions(select, values) {
    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function getDefaultPageSize() {
    return window.matchMedia("(max-width: 767px)").matches ? "10" : "25";
  }

  function applyDefaultPageSize() {
    pageSizeSelect.value = getDefaultPageSize();
  }

  function levenshteinDistance(a, b) {
    if (a === b) return 0;
    if (!a) return b.length;
    if (!b) return a.length;

    var rows = a.length + 1;
    var cols = b.length + 1;
    var matrix = [];

    for (var row = 0; row < rows; row += 1) {
      matrix[row] = [row];
    }

    for (var col = 1; col < cols; col += 1) {
      matrix[0][col] = col;
    }

    for (row = 1; row < rows; row += 1) {
      for (col = 1; col < cols; col += 1) {
        var cost = a.charAt(row - 1) === b.charAt(col - 1) ? 0 : 1;
        matrix[row][col] = Math.min(
          matrix[row - 1][col] + 1,
          matrix[row][col - 1] + 1,
          matrix[row - 1][col - 1] + cost
        );
      }
    }

    return matrix[a.length][b.length];
  }

  function similarityRatio(a, b) {
    var longest = Math.max(a.length, b.length);
    if (!longest) return 1;
    return 1 - (levenshteinDistance(a, b) / longest);
  }

  function matchesSearch(row, query) {
    if (!query.readable && !query.compact) return true;

    var readableMatch = query.readable && (
      row.normalisedFullText.indexOf(query.readable) !== -1 ||
      row.normalisedBrand.indexOf(query.readable) !== -1 ||
      row.normalisedModel.indexOf(query.readable) !== -1
    );

    var compactMatch = query.compact && (
      row.compactFullText.indexOf(query.compact) !== -1 ||
      row.compactBrand.indexOf(query.compact) !== -1 ||
      row.compactModel.indexOf(query.compact) !== -1 ||
      row.compactBrandModel.indexOf(query.compact) !== -1
    );

    var tokenMatch = query.tokens.length && query.tokens.every(function (token) {
      return row.normalisedFullText.indexOf(token) !== -1;
    });

    return Boolean(readableMatch || compactMatch || tokenMatch);
  }

  function scoreClosestMatch(row, query) {
    if (!query.compact) return -1;

    var score = 0;
    var compactTargets = [row.compactBrandModel, row.compactModel, row.compactBrand, row.compactFullText];
    var readableTargets = [row.normalisedBrandModel, row.normalisedModel, row.normalisedBrand, row.normalisedFullText];

    compactTargets.forEach(function (target, index) {
      if (!target) return;
      if (target === query.compact) {
        score = Math.max(score, index === 0 ? 120 : 110);
        return;
      }
      if (target.indexOf(query.compact) !== -1 || query.compact.indexOf(target) !== -1) {
        score = Math.max(score, index === 0 ? 100 : 92);
      }
      var similarity = similarityRatio(query.compact, target);
      if (similarity >= 0.86) {
        score = Math.max(score, Math.round(similarity * 100));
      }
    });

    if (query.tokens.length) {
      var tokenHits = query.tokens.filter(function (token) {
        return row.normalisedFullText.indexOf(token) !== -1;
      }).length;
      if (tokenHits) {
        score = Math.max(score, Math.round((tokenHits / query.tokens.length) * 78));
      }
    }

    readableTargets.forEach(function (target) {
      if (!target || !query.readable) return;
      var similarity = similarityRatio(query.readable, target);
      if (similarity >= 0.8) {
        score = Math.max(score, Math.round(similarity * 90));
      }
    });

    if (query.compact.length <= 3 && score < 95) return -1;
    if (score < 72) return -1;

    return score;
  }

  function getHeaderRows() {
    if (table.tHead && table.tHead.rows.length) {
      return Array.prototype.slice.call(table.tHead.rows);
    }

    var firstRow = table.rows[0];
    if (!firstRow) return [];

    var hasHeaderCells = Array.prototype.some.call(firstRow.cells, function (cell) {
      return cell.tagName.toLowerCase() === "th";
    });

    var headerLike = Array.prototype.slice.call(firstRow.cells).map(getCellText).join(" ").toLowerCase();
    var looksLikeHeader = headerLike.indexOf("excavator") !== -1 &&
      headerLike.indexOf("model") !== -1 &&
      headerLike.indexOf("weight") !== -1;

    if (!hasHeaderCells && !looksLikeHeader) return [];

    Array.prototype.slice.call(firstRow.cells).forEach(function (cell) {
      if (cell.tagName.toLowerCase() === "th") return;

      var th = document.createElement("th");
      th.innerHTML = cell.innerHTML;
      Array.prototype.slice.call(cell.attributes).forEach(function (attribute) {
        th.setAttribute(attribute.name, attribute.value);
      });
      cell.parentNode.replaceChild(th, cell);
    });

    table.createTHead().appendChild(firstRow);
    return [firstRow];
  }

  function prepareTable() {
    table.classList.add("digger-hitch-size__table");

    if (!table.parentElement.classList.contains("digger-hitch-size__table-wrap")) {
      var wrap = document.createElement("div");
      wrap.className = "digger-hitch-size__table-wrap";
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    }

    var headerRows = getHeaderRows();
    var headerCells = headerRows.length ? Array.prototype.slice.call(headerRows[headerRows.length - 1].cells) : [];
    headerLabels = headerCells.map(function (cell) {
      cell.setAttribute("scope", "col");
      return getCellText(cell);
    });

    if (!headerLabels.length) {
      headerLabels = ["Excavator", "Model", "Weight", "Centre", "Diameter", "Dipper Width", "Front length", "Back length", "Bolt centre", "Bolt hole", "Note"];
    }

    headerLabels.forEach(function (label, index) {
      if (normalise(label) === "weight") weightIndex = index;
    });

    var bodyRows = table.tBodies.length ? Array.prototype.slice.call(table.tBodies[0].rows) : Array.prototype.slice.call(table.rows);

    rows = bodyRows.filter(function (row) {
      return headerRows.indexOf(row) === -1 && row.cells.length;
    }).map(function (row) {
      var cells = Array.prototype.slice.call(row.cells);
      var textValues = cells.map(getCellText);
      var brand = textValues[0] || "";
      var weight = textValues[weightIndex] || "";

      cells.forEach(function (cell, index) {
        var label = headerLabels[index] || "";
        var text = getCellText(cell);
        cell.setAttribute("data-label", label);

        if (!text) {
          cell.setAttribute("data-empty", "true");
          if (normalise(label) !== "note") {
            cell.innerHTML = '<span class="digger-hitch-size__dash" aria-label="Not specified">-</span>';
          }
        }
      });

      if (brand) brandValues.push(brand);
      if (weight) weightValues.push(weight);

      return {
        element: row,
        cellValues: textValues,
        brand: brand,
        model: textValues[1] || "",
        weight: weight,
        fullText: textValues.join(" "),
        normalisedFullText: normaliseSearchValue(textValues.join(" ")).readable,
        compactFullText: normaliseSearchValue(textValues.join(" ")).compact,
        normalisedBrand: normaliseSearchValue(brand).readable,
        compactBrand: normaliseSearchValue(brand).compact,
        normalisedModel: normaliseSearchValue(textValues[1] || "").readable,
        compactModel: normaliseSearchValue(textValues[1] || "").compact,
        normalisedBrandModel: normaliseSearchValue(brand + " " + (textValues[1] || "")).readable,
        compactBrandModel: normaliseSearchValue(brand + " " + (textValues[1] || "")).compact,
        weightKey: normalise(weight)
      };
    });
  }

  function updateResults() {
    var query = normaliseSearchValue(searchInput.value);
    var brand = normalise(brandSelect.value);
    var weight = normalise(weightSelect.value);
    var pageSize = parseInt(pageSizeSelect.value, 10) || 25;
    var filteredRows = rows.filter(function (row) {
      return (!brand || row.normalisedBrand === brand) &&
        (!weight || row.weightKey === weight);
    });
    var matchingRows = filteredRows.filter(function (row) {
      return matchesSearch(row, query);
    });
    var isClosestMatchMode = false;

    if (!matchingRows.length && query.readable) {
      matchingRows = filteredRows.map(function (row) {
        return {
          row: row,
          score: scoreClosestMatch(row, query)
        };
      }).filter(function (candidate) {
        return candidate.score >= 0;
      }).sort(function (a, b) {
        return b.score - a.score;
      }).slice(0, closestMatchLimit).map(function (candidate) {
        return candidate.row;
      });

      isClosestMatchMode = matchingRows.length > 0;
    }

    var totalMatches = matchingRows.length;
    var totalPages = Math.max(1, Math.ceil(totalMatches / pageSize));

    if (currentPage > totalPages) currentPage = totalPages;

    var startIndex = totalMatches ? (currentPage - 1) * pageSize : 0;
    var endIndex = Math.min(startIndex + pageSize, totalMatches);
    var visibleRows = matchingRows.slice(startIndex, endIndex);

    rows.forEach(function (row) {
      row.element.hidden = true;
    });

    visibleRows.forEach(function (row) {
      row.element.hidden = false;
    });

    suggestionMessage.hidden = true;
    suggestionMessage.textContent = "";

    if (isClosestMatchMode) {
      suggestionMessage.hidden = false;
      suggestionMessage.innerHTML = "No exact matches found. Showing closest matches for '" + escapeHtml(searchInput.value.trim()) + "'.";
      resultCount.textContent = "Showing " + (startIndex + 1) + "-" + endIndex + " of " + totalMatches + " closest matches";
    } else if (totalMatches) {
      resultCount.textContent = "Showing " + (startIndex + 1) + "-" + endIndex + " of " + totalMatches + " matching " + (totalMatches === 1 ? "result" : "results");
    } else {
      resultCount.textContent = "No hitch sizes match your search.";
    }

    emptyState.hidden = totalMatches !== 0;

    renderPageNumbers(totalPages, totalMatches);
  }

  function resetToFirstPage() {
    currentPage = 1;
    updateResults();
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(fn, wait);
    };
  }

  function getPaginationItems(totalPages) {
    var items = [];
    var lastPageAdded = 0;

    for (var pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
      var shouldShow = pageNumber === 1 ||
        pageNumber === totalPages ||
        Math.abs(pageNumber - currentPage) <= 2;

      if (!shouldShow) continue;

      if (lastPageAdded && pageNumber - lastPageAdded > 1) {
        items.push("ellipsis");
      }

      items.push(pageNumber);
      lastPageAdded = pageNumber;
    }

    return items;
  }

  function renderPageNumbers(totalPages, totalMatches) {
    var items = totalMatches ? getPaginationItems(totalPages) : [];

    pageNumberContainers.forEach(function (container) {
      container.innerHTML = "";
      container.parentElement.hidden = totalPages <= 1;

      items.forEach(function (item) {
        if (item === "ellipsis") {
          var ellipsis = document.createElement("span");
          ellipsis.className = "digger-hitch-size__pagination-ellipsis";
          ellipsis.textContent = "...";
          container.appendChild(ellipsis);
          return;
        }

        var button = document.createElement("button");
        button.type = "button";
        button.textContent = item;
        button.setAttribute("aria-label", "Go to page " + item);

        if (item === currentPage) {
          button.setAttribute("aria-current", "page");
        }

        button.addEventListener("click", function () {
          currentPage = item;
          updateResults();
        });

        container.appendChild(button);
      });
    });
  }

  prepareTable();
  addOptions(brandSelect, uniqueSorted(brandValues));
  addOptions(weightSelect, uniqueSorted(weightValues));
  applyDefaultPageSize();
  filters.hidden = false;
  paginationGroups.forEach(function (group) {
    var pageNumbers = document.createElement("div");
    pageNumbers.className = "digger-hitch-size__page-numbers";
    pageNumbers.setAttribute("aria-label", "Hitch size table pages");
    group.appendChild(pageNumbers);
    pageNumberContainers.push(pageNumbers);
    group.hidden = false;
  });

  var debouncedUpdate = debounce(resetToFirstPage, 150);
  searchInput.addEventListener("input", debouncedUpdate);
  brandSelect.addEventListener("change", resetToFirstPage);
  weightSelect.addEventListener("change", resetToFirstPage);
  pageSizeSelect.addEventListener("change", function () {
    hasUserSetPageSize = true;
    resetToFirstPage();
  });
  clearButton.addEventListener("click", function () {
    searchInput.value = "";
    brandSelect.value = "";
    weightSelect.value = "";
    hasUserSetPageSize = false;
    applyDefaultPageSize();
    currentPage = 1;
    suggestionMessage.hidden = true;
    suggestionMessage.textContent = "";
    updateResults();
    searchInput.focus();
  });

  updateResults();
})();
